import React from 'react';
import SuccessModal from './SuccessModal';
import SaveModal from './SaveModal';
import PropTypes from 'prop-types';
import ErrorModal from './ErrorModal';

const DLCModal = ({
  showSuccessModal,
  showSaveModal,
  isSuccess,
  handleShowSuccessModal,
  handleShowSaveModal,
  handleShowScheduleMessageModal,
  error,
}) => (
  <div>
    {showSuccessModal && isSuccess ? (
      <SuccessModal show={showSuccessModal} handleShowSuccessModal={handleShowSuccessModal} />
    ) : null}
    {showSaveModal && isSuccess ? (
      <SaveModal
        show={showSaveModal}
        handleShowSaveModal={handleShowSaveModal}
        handleShowScheduleMessageModal={handleShowScheduleMessageModal}
      />
    ) : null}
    {error ? <ErrorModal show={error} errorMessage={error} /> : null}
  </div>
);

DLCModal.propTypes = {
  showSuccessModal: PropTypes.bool,
  showSaveModal: PropTypes.bool,
  isSuccess: PropTypes.bool,
  handleShowScheduleMessageModal: PropTypes.func,
  handleShowSuccessModal: PropTypes.func,
  handleShowSaveModal: PropTypes.func,
  error: PropTypes.string,
};

export default DLCModal;
